(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ajura-complete-set"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ajura-complete-set')) {

    class AjuraCompleteSet extends HTMLElement {

      connectedCallback() {

        this.dataElement =
          this.querySelector(
            '[data-ajura-complete-set-data]'
          );


        this.products = [];


        try {

          this.products =
            JSON.parse(
              this.dataElement?.textContent || '[]'
            );

        } catch (error) {

          console.error(
            'AJURA Complete Set data error:',
            error
          );

          return;

        }


        this.selectedProductId =
          Number(
            this.dataset.selectedProduct
          );


        this.selectedVariantId =
          null;


        this.addEventListener(
          'click',
          this.handleClick
        );

      }


      disconnectedCallback() {

        this.removeEventListener(
          'click',
          this.handleClick
        );


        this.restoreOriginalSizeGuide();

      }


      /* =====================================================
         CLICK HANDLER
         ===================================================== */

      handleClick = (event) => {

        const swatch =
          event.target.closest(
            '[data-ajura-swatch]'
          );


        const size =
          event.target.closest(
            '[data-ajura-size]'
          );


        const addButton =
          event.target.closest(
            '[data-ajura-add]'
          );


        const sizeGuideTrigger =
          event.target.closest(
            '[data-ajura-size-guide-trigger]'
          );


        if (swatch) {

          this.selectProduct(
            Number(
              swatch.dataset.productId
            )
          );

          return;

        }


        if (
          size &&
          !size.disabled
        ) {

          this.selectVariant(
            Number(
              size.dataset.variantId
            )
          );

          return;

        }


        if (sizeGuideTrigger) {

          this.openExistingSizeGuide();

          return;

        }


        if (addButton) {

          this.addComplementaryItem();

        }

      };


      /* =====================================================
         SELECTED PRODUCT
         ===================================================== */

      getSelectedProduct() {

        return this.products.find(
          (item) =>
            Number(item.id) ===
            Number(this.selectedProductId)
        );

      }


      /* =====================================================
         COLOUR / PRODUCT
         ===================================================== */

      selectProduct(productId) {

        const selectedProduct =
          this.products.find(
            (item) =>
              Number(item.id) ===
              Number(productId)
          );


        if (!selectedProduct) {
          return;
        }


        this.selectedProductId =
          Number(productId);


        this.selectedVariantId =
          null;


        this.querySelectorAll(
          '[data-ajura-swatch]'
        ).forEach((button) => {

          const isSelected =
            Number(
              button.dataset.productId
            ) ===
            this.selectedProductId;


          button.classList.toggle(
            'is-selected',
            isSelected
          );


          button.setAttribute(
            'aria-pressed',
            isSelected
              ? 'true'
              : 'false'
          );

        });


        const title =
          this.querySelector(
            '[data-ajura-product-title]'
          );


        const productLink =
          this.querySelector(
            '[data-ajura-product-link]'
          );


        const colourName =
          this.querySelector(
            '[data-ajura-colour-name]'
          );


        const colourValue =
          this.querySelector(
            '[data-ajura-colour-value]'
          );


        const image =
          this.querySelector(
            '[data-ajura-image]'
          );


        const sizeGuideTrigger =
          this.querySelector(
            '[data-ajura-size-guide-trigger]'
          );


        if (title) {

          title.textContent =
            selectedProduct.title || '';

        }


        if (productLink) {

          productLink.href =
            selectedProduct.url || '#';

        }


        if (colourName) {

          colourName.textContent =
            selectedProduct.colorName || '';

        }


        if (colourValue) {

          colourValue.textContent =
            selectedProduct.colorName || '';

        }


        if (
          image &&
          selectedProduct.image
        ) {

          image.src =
            selectedProduct.image;


          image.srcset =
            '';


          image.alt =
            selectedProduct.title || '';

        }


        if (sizeGuideTrigger) {

          sizeGuideTrigger.hidden =
            !selectedProduct.hasSizeGuide;

        }


        this.renderSizes(
          selectedProduct
        );


        this.updateAddButton();


        this.clearError();

      }


      /* =====================================================
         SIZES
         ===================================================== */

      renderSizes(product) {

        const container =
          this.querySelector(
            '[data-ajura-sizes]'
          );


        const sizeValue =
          this.querySelector(
            '[data-ajura-size-value]'
          );


        if (!container) {
          return;
        }


        container.innerHTML =
          '';


        product.variants.forEach(
          (variant) => {

            const button =
              document.createElement(
                'button'
              );


            button.type =
              'button';


            button.className =
              'ajura-complete-set__size';


            button.dataset.ajuraSize =
              '';


            button.dataset.variantId =
              variant.id;


            button.setAttribute(
              'aria-pressed',
              'false'
            );


            if (!variant.available) {

              button.disabled =
                true;

            }


            const text =
              document.createElement(
                'span'
              );


            text.className =
              'ajura-complete-set__size-text';


            text.textContent =
              variant.title;


            button.appendChild(
              text
            );


            container.appendChild(
              button
            );

          }
        );


        if (sizeValue) {

          sizeValue.textContent =
            'Select';

        }

      }


      selectVariant(variantId) {

        const product =
          this.getSelectedProduct();


        const variant =
          product?.variants.find(
            (item) =>
              Number(item.id) ===
              Number(variantId)
          );


        if (
          !variant ||
          !variant.available
        ) {

          return;

        }


        this.selectedVariantId =
          Number(variantId);


        this.querySelectorAll(
          '[data-ajura-size]'
        ).forEach((button) => {

          const selected =
            Number(
              button.dataset.variantId
            ) ===
            this.selectedVariantId;


          button.classList.toggle(
            'is-selected',
            selected
          );


          button.setAttribute(
            'aria-pressed',
            selected
              ? 'true'
              : 'false'
          );

        });


        const sizeValue =
          this.querySelector(
            '[data-ajura-size-value]'
          );


        if (sizeValue) {

          sizeValue.textContent =
            variant.title;

        }


        this.updateAddButton();


        this.clearError();

      }


      updateAddButton() {

        const button =
          this.querySelector(
            '[data-ajura-add]'
          );


        if (!button) {
          return;
        }


        button.disabled =
          !this.selectedVariantId;

      }


      /* =====================================================
         EXISTING HORIZON SIZE GUIDE
         ===================================================== */

      findExistingSizeGuidePopup() {

        const popups =
          Array.from(
            document.querySelectorAll(
              'dialog-component.popup-link'
            )
          );


        return popups.find(
          (popup) => {

            const trigger =
              popup.querySelector(
                '.popup-link__button'
              );


            if (!trigger) {
              return false;
            }


            const label =
              trigger.textContent
                ?.replace(/\s+/g, ' ')
                .trim()
                .toLowerCase();


            return (
              label === 'size guide' ||
              label?.includes('size guide')
            );

          }
        );

      }


      openExistingSizeGuide() {

        const product =
          this.getSelectedProduct();


        if (
          !product ||
          !product.hasSizeGuide
        ) {

          return;

        }


        const template =
          this.querySelector(
            `[data-ajura-size-guide-template][data-product-id="${product.id}"]`
          );


        if (!template) {

          this.showError(
            'Size guide unavailable.'
          );

          return;

        }


        const popup =
          this.findExistingSizeGuidePopup();


        if (!popup) {

          this.showError(
            'Size guide drawer could not be found.'
          );

          return;

        }


        const popupInner =
          popup.querySelector(
            '.popup-link__inner'
          );


        const dialog =
          popup.querySelector(
            'dialog'
          );


        if (
          !popupInner ||
          !dialog
        ) {

          this.showError(
            'Size guide drawer could not be found.'
          );

          return;

        }


        this.restoreOriginalSizeGuide();


        this.activeSizeGuidePopup =
          popup;


        this.activeSizeGuideInner =
          popupInner;


        this.activeSizeGuideDialog =
          dialog;


        this.originalSizeGuideHTML =
          popupInner.innerHTML;


        popupInner.innerHTML =
          '';


        popupInner.appendChild(
          template.content.cloneNode(true)
        );


        dialog.addEventListener(
          'close',
          this.handleExistingSizeGuideClose,
          {
            once: true
          }
        );


        this.clearError();


        if (
          typeof popup.showDialog ===
          'function'
        ) {

          popup.showDialog();

          return;

        }


        if (
          typeof dialog.showModal ===
            'function' &&
          !dialog.open
        ) {

          dialog.showModal();

        }

      }


      handleExistingSizeGuideClose =
        () => {

          this.restoreOriginalSizeGuide();

        };


      restoreOriginalSizeGuide() {

        if (
          this.activeSizeGuideInner &&
          typeof this.originalSizeGuideHTML ===
            'string'
        ) {

          this.activeSizeGuideInner.innerHTML =
            this.originalSizeGuideHTML;

        }


        if (
          this.activeSizeGuideDialog
        ) {

          this.activeSizeGuideDialog.removeEventListener(
            'close',
            this.handleExistingSizeGuideClose
          );

        }


        this.activeSizeGuidePopup =
          null;


        this.activeSizeGuideInner =
          null;


        this.activeSizeGuideDialog =
          null;


        this.originalSizeGuideHTML =
          null;

      }


      /* =====================================================
         ADD ONLY THE COMPLEMENTARY ITEM
         ===================================================== */

      async addComplementaryItem() {

        const button =
          this.querySelector(
            '[data-ajura-add]'
          );


        if (
          !button ||
          button.disabled ||
          !this.selectedVariantId
        ) {

          return;

        }


        const selectedProduct =
          this.getSelectedProduct();


        if (!selectedProduct) {

          this.showError(
            'Please select an item.'
          );

          return;

        }


        const itemLabel =
          this.dataset.itemLabel ||
          'ITEM';


        const originalText =
          button.textContent;


        button.disabled =
          true;


        button.textContent =
          `ADDING ${itemLabel}…`;


        this.clearError();


        try {

          /*
           * IMPORTANT:
           *
           * This adds ONLY the selected complementary
           * variant.
           *
           * It does NOT submit the current PDP product.
           */

          if (
            window.Shopify?.actions?.updateCart
          ) {

            const result =
              await window.Shopify.actions.updateCart({
                lines: [
                  {
                    merchandiseId:
                      `gid://shopify/ProductVariant/${this.selectedVariantId}`,

                    quantity:
                      1
                  }
                ]
              });


            const userErrors =
              result?.userErrors || [];


            if (
              Array.isArray(userErrors) &&
              userErrors.length
            ) {

              throw new Error(
                userErrors
                  .map(
                    (error) =>
                      error.message
                  )
                  .filter(Boolean)
                  .join(' ')
              );

            }


            button.textContent =
              `${itemLabel} ADDED`;


            if (
              window.Shopify.actions.openCart
            ) {

              await window.Shopify.actions.openCart();

            }

          } else {

            /*
             * Defensive fallback for an older
             * storefront runtime.
             */

            const root =
              window.Shopify?.routes?.root ||
              '/';


            const response =
              await fetch(
                `${root}cart/add.js`,
                {
                  method:
                    'POST',

                  credentials:
                    'same-origin',

                  headers: {
                    'Content-Type':
                      'application/json',

                    Accept:
                      'application/json'
                  },

                  body:
                    JSON.stringify({
                      items: [
                        {
                          id:
                            Number(
                              this.selectedVariantId
                            ),

                          quantity:
                            1
                        }
                      ]
                    })
                }
              );


            const result =
              await response.json();


            if (
              !response.ok ||
              result.status
            ) {

              throw new Error(
                result.description ||
                result.message ||
                `Unable to add ${itemLabel.toLowerCase()}.`
              );

            }


            button.textContent =
              `${itemLabel} ADDED`;


            /*
             * Old-runtime fallback:
             * redirect to cart so the customer never
             * sees stale cart data.
             */

            window.location.assign(
              `${root}cart`
            );


            return;

          }


          window.setTimeout(
            () => {

              button.textContent =
                originalText;


              this.updateAddButton();

            },
            1300
          );


        } catch (error) {

          console.error(
            'AJURA Complete Set:',
            error
          );


          button.textContent =
            originalText;


          this.updateAddButton();


          this.showError(
            error?.message ||
            'Something went wrong. Please try again.'
          );

        }

      }


      /* =====================================================
         ERROR
         ===================================================== */

      showError(message) {

        const error =
          this.querySelector(
            '[data-ajura-error]'
          );


        if (!error) {
          return;
        }


        error.textContent =
          message;


        error.hidden =
          false;

      }


      clearError() {

        const error =
          this.querySelector(
            '[data-ajura-error]'
          );


        if (!error) {
          return;
        }


        error.textContent =
          '';


        error.hidden =
          true;

      }

    }


    customElements.define(
      'ajura-complete-set',
      AjuraCompleteSet
    );

  }
  } catch(e) { console.error(e); }
})();

})();
